import { MissionControlHeader, MissionControlSidebar } from '@vitvio/mission-control';
import { Layout, Page } from '@vitvio/navigation';
import { OrganizationManagement } from '@vitvio/organization-management';
import { useUserContext } from '@vitvio/user-context';

export function OrganizationManagementPage() {
  const { organization } = useUserContext();
  return (
    <Page title={organization?.name || ''}>
      <Layout topbarHeader={<MissionControlHeader />} sidebar={<MissionControlSidebar />} appName="platform">
        <OrganizationManagement />
      </Layout>
    </Page>
  );
}
